// extracted by mini-css-extract-plugin
module.exports = {"deleteClubSection":"_06998d9","deleteClubTitle":"_7001e94","deleteClubInstructions":"_c163bad","deleteClubEmail":"_f41ff2e"};